var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 114,
    viewBox: "0 0 186 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    width: 186,
    height: 114,
    transform: "translate(-0.116)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    d: "M22.635,294.845c13.754,7.5,37.512,0,37.512,0,60.435-27.2,90.036-90.906,99.264-114.653a14.286,14.286,0,0,1,13.308-9.135h.039a14.278,14.278,0,0,1,13.268,9.03c9.389,23.665,39.531,87.522,100.056,114.758,0,0,23.757,7.5,37.512,0s0,12.5-26.258,11.253a88.658,88.658,0,0,1-15.051-1.762l-3.7,9.264s-58.27-32.45-89.779-102.5c7.21,45.238,22.462,114.733,49.733,131.26H107.694c27.271-16.528,42.523-86.023,49.733-131.26C125.919,281.152,67.65,313.6,67.65,313.6l-3.706-9.264a88.659,88.659,0,0,1-15.05,1.762C22.635,307.349,8.881,287.343,22.635,294.845Z",
    transform: "translate(-17.215 -171.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M114.752,327.433H232.719s49.947-1.427,57.081-8.563c4.281-4.28-156.973-31.395-185.514-20.929S91.919,327.433,114.752,327.433Z",
    transform: "translate(-89.032 -295.557)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    d: "M158.084,173.578s24.382-13.129,24.382-35.636-9.378-31.885-33.135-30.634-31.26-1.25-31.26-1.25-1.25,8.753,15,15,23.757,8.753,23.757,8.753l-6.252,16.255Z",
    transform: "translate(-118.05 -106.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M159.064,187.618V170.573l8.753-17.505s6.877.625,5.627-8.127-4.376-3.126-8.127.625c-1.8,1.8-4.456,1.3-6.326-1.5-2.032-3.038,4.45-7.88-1.177-17.258l-23.757-8.753s4.376,14.379-1.876,23.132c-3.278,4.589-6.252,6.252-6.252,8.753s4.376,3.126,8.753-1.25c0,0-.625,34.386,14.379,23.132l-.91,15.473a5.462,5.462,0,0,0,5.452,5.783h0a5.462,5.462,0,0,0,5.461-5.459Z",
    transform: "translate(-125.929 -118.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M163.217,327.436H34s.443-4.368.443-9.369c0-.348.263-.988,0-1.251-1-1-1.506-.36,0-2.5.593-.844.22-2.069,1.25-3.751.394-.646-2.693-2.047,0-2.5,48.8-8.241,119.752-16.808,137.994-10.119C202.222,308.409,186.05,327.436,163.217,327.436Z",
    transform: "translate(-33.489 -295.545)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968",
    transform: "translate(-996.999 -165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952",
    transform: "translate(78.126 -12.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exclamation-triangle-solid",
    d: "M76.566,59.156a6.457,6.457,0,0,1-5.59,9.678H6.46A6.457,6.457,0,0,1,.87,59.156L33.129,3.225a6.457,6.457,0,0,1,11.179,0ZM38.719,47.592A6.184,6.184,0,1,0,44.9,53.775a6.184,6.184,0,0,0-6.181-6.183ZM32.847,25.363l1,18.284a1.613,1.613,0,0,0,1.611,1.525h6.527A1.613,1.613,0,0,0,43.6,43.647l1-18.284a1.613,1.613,0,0,0-1.611-1.7H34.458a1.613,1.613,0,0,0-1.611,1.7Z",
    transform: "translate(957.718 200.205)",
    fill: "#ef953c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(997.115 165)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967",
    transform: "translate(-15.379 -3.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954",
    transform: "translate(0 81.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M22.635,294.845c13.754,7.5,37.512,0,37.512,0,60.435-27.2,90.036-90.906,99.264-114.653a14.286,14.286,0,0,1,13.308-9.135h.039a14.278,14.278,0,0,1,13.268,9.03c9.389,23.665,39.531,87.522,100.056,114.758,0,0,23.757,7.5,37.512,0s0,12.5-26.258,11.253a88.658,88.658,0,0,1-15.051-1.762l-3.7,9.264s-58.27-32.45-89.779-102.5c7.21,45.238,22.462,114.733,49.733,131.26H107.694c27.271-16.528,42.523-86.023,49.733-131.26C125.919,281.152,67.65,313.6,67.65,313.6l-3.706-9.264a88.659,88.659,0,0,1-15.05,1.762C22.635,307.349,8.881,287.343,22.635,294.845Z",
    transform: "translate(-17.215 -171.057)",
    fill: "#282829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M279.066,256.557l8.753,16.255,3.751,10L244.055,307.82l-15-37.511L240.3,256.557Z",
    transform: "translate(-244.647 -149.649)",
    fill: "#f4d9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M11.05,283.316l5-10L29.8,254.56l36.261,7.5-5,30.009-31.26,11.253Z",
    transform: "translate(253.439 -150.15)",
    fill: "#f4d9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M155.6,286.841c-1.25,0-9.908,19.815-47.467,9.907S10.551,210.568,8.05,175.557l42.981,15.62,113.317,88.162Z",
    transform: "translate(158.91 -169.93)",
    fill: "#fff",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M159.8,285.841c1.25,0,9.907,19.815,47.466,9.907s97.579-86.18,100.079-121.191l-42.981,15.62L151.05,278.339Z",
    transform: "translate(-162.895 -170.181)",
    fill: "#fff",
    opacity: 0.18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956",
    transform: "translate(21.147 236.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    d: "M114.752,327.433H232.719s49.947-1.427,57.081-8.563c4.281-4.28-156.973-31.395-185.514-20.929S91.919,327.433,114.752,327.433Z",
    transform: "translate(-89.032 -295.557)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M131.314,353.147,248.463,339.27s49.433-7.293,55.678-15.218c3.747-4.754-159.576-12.711-186.688,1.039S108.64,355.832,131.314,353.147Z",
    transform: "translate(-121.957 -290.086)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M87.011,339.439H221.7s57.026-2.323,65.174-13.935c4.888-6.968-179.226-51.1-211.814-34.067S60.942,339.439,87.011,339.439Z",
    transform: "translate(-46.874 -297.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M211.345,301.557c1.25,23.757-78.332,1.234-85.026,24.374s2.5,16.889,2.5,16.889l81.275-3.751,10.219-29.076Z",
    transform: "translate(-63.031 -294.054)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M195.691,308.574c-.683-.683-24.192,2.958-48.765,5-14.257,1.185-33.144-1.008-35.011,2.5-.817,1.532,11.721,6.852,15,8.753,20.848,12.069-5,20.006-5,20.006l81.275-3.751,10.219-29.076Z",
    transform: "translate(-41.125 -292.319)",
    fill: "#e3e3e3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961",
    transform: "translate(121.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M158.084,173.578s24.382-13.129,24.382-35.636-9.378-31.885-33.135-30.634-31.26-1.25-31.26-1.25-1.25,8.753,15,15,23.757,8.753,23.757,8.753l-6.252,16.255Z",
    transform: "translate(-118.05 -106.057)",
    fill: "#925f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M113.135,108.557s48.765,22.507,67.521,18.756,10,26.258-2.5,41.263-31.26,5-31.26,5l-37.511-40.012Z",
    transform: "translate(-116.239 -105.431)",
    fill: "#542700",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M120.052,101.557l48.765,3.751,15,20.006-3.751,3.751s-11.253-13.754-32.51-13.754-32.51-7.5-32.51-7.5Z",
    transform: "translate(-115.653 -107.184)",
    fill: "#a88143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960",
    transform: "translate(6.899 15.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M159.064,187.618V170.573l8.753-17.505s6.877.625,5.627-8.127-4.376-3.126-8.127.625c-1.8,1.8-4.456,1.3-6.326-1.5-2.032-3.038,4.45-7.88-1.177-17.258l-23.757-8.753s4.376,14.379-1.876,23.132c-3.278,4.589-6.252,6.252-6.252,8.753s4.376,3.126,8.753-1.25c0,0-.625,34.386,14.379,23.132l-.91,15.473a5.462,5.462,0,0,0,5.452,5.783h0a5.462,5.462,0,0,0,5.461-5.459Z",
    transform: "translate(-125.929 -118.057)",
    fill: "#e3c3aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M133.236,118.557s7.5,15,3.751,26.258-.72,26.143-14.114,26.826,5.362,8.185,5.362,8.185v16.255l20.006,6.252,8.753-12.5-2.5-18.756L167,153.568l-5-23.757Z",
    transform: "translate(-109.479 -117.932)",
    fill: "#e0b7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M152.053,161.058l3.751-2.5v30.009l-13.754-8.753s5-10,6.252-11.253S152.053,161.058,152.053,161.058Z",
    transform: "translate(-128.296 -107.916)",
    fill: "#cea293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M162.553,143.057l2.5-2.5-1.25,13.754H155.05l5-7.5Z",
    transform: "translate(-153.801 -112.423)",
    fill: "#eac5b5"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.574,
    cy: 3.328,
    rx: 1.574,
    ry: 3.328,
    transform: "matrix(-0.98, -0.198, 0.198, -0.98, 26.659, 36.721)",
    fill: "#4b4b4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.574,
    cy: 3.328,
    rx: 1.574,
    ry: 3.328,
    transform: "matrix(-0.98, -0.198, 0.198, -0.98, 20.407, 35.471)",
    fill: "#4b4b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M127.652,143.592s3.751-6.252,5-5,1.25,7.5-2.5,7.5S127.652,143.592,127.652,143.592Z",
    transform: "translate(-80.74 -97.953)",
    fill: "#cea293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M147.05,153.684s8.753,1.25,11.879-8.127",
    transform: "translate(175.206 203.129) rotate(180)",
    fill: "none",
    stroke: "#4b4b4d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 8.453,
    cy: 9.901,
    rx: 8.453,
    ry: 9.901,
    transform: "translate(164.228 131.807) rotate(-179.714)",
    fill: "#33c999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M140.109,205.017a4.238,4.238,0,0,1,.626-.554,4.273,4.273,0,0,1-.621-.562,5.74,5.74,0,0,1-1.377-3.1,1.1,1.1,0,0,1,.174-.768.729.729,0,0,1,.6-.339.836.836,0,0,1,.759.765,4.162,4.162,0,0,0,.824,1.912,2.031,2.031,0,0,0,3.371.007,4.244,4.244,0,0,0,.845-1.9.839.839,0,0,1,.766-.754h0a.729.729,0,0,1,.6.345,1.1,1.1,0,0,1,.166.77,5.744,5.744,0,0,1-1.41,3.085,4.174,4.174,0,0,1-.626.554,4.2,4.2,0,0,1,.621.56,5.732,5.732,0,0,1,1.377,3.1,1.1,1.1,0,0,1-.173.768.733.733,0,0,1-.6.339.837.837,0,0,1-.759-.765,4.18,4.18,0,0,0-.823-1.912,2.03,2.03,0,0,0-3.371-.006,4.244,4.244,0,0,0-.847,1.9.838.838,0,0,1-.766.754h0a.733.733,0,0,1-.6-.345,1.11,1.11,0,0,1-.166-.769A5.74,5.74,0,0,1,140.109,205.017Z",
    transform: "translate(13.056 -82.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M160.084,305.353s1.751,15.572-1.293,19.167S151.917,306.348,160.084,305.353Z",
    transform: "translate(-21.299 -56.157)",
    fill: "#282829"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 8.168,
    cy: 25.008,
    rx: 8.168,
    ry: 25.008,
    transform: "translate(89.043 270.628) rotate(-95.64)",
    fill: "#47484a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.69,
    cy: 11.445,
    rx: 4.69,
    ry: 11.445,
    transform: "translate(117.297 264.282) rotate(-95.64)",
    fill: "#282829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M155.027,314.051h0a3.969,3.969,0,0,1,3.637-4.612l9.083-.638s.934,5.568,0,8.883l-8.948-.32a3.971,3.971,0,0,1-3.772-3.313Z",
    transform: "translate(-28.613 -55.293)",
    fill: "#f4d9c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965",
    transform: "translate(136.001 236.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M163.217,327.436H34s.443-4.368.443-9.369c0-.348.263-.988,0-1.251-1-1-1.506-.36,0-2.5.593-.844.22-2.069,1.25-3.751.394-.646-2.693-2.047,0-2.5,48.8-8.241,119.752-16.808,137.994-10.119C202.222,308.409,186.05,327.436,163.217,327.436Z",
    transform: "translate(-33.489 -295.545)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M163.217,322.425H34a5.318,5.318,0,0,0,.443-2.018c0-.075.263-.213,0-.269-1-.215-1.506-.078,0-.539.593-.181.22-.445,1.25-.808.394-.139-2.693-.441,0-.539,48.8-1.774,119.752-3.62,137.994-2.179C202.222,318.328,186.05,322.425,163.217,322.425Z",
    transform: "translate(-33.489 -290.534)",
    fill: "#e3e3e3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M236.464,317.818s-2.026-11.552-37.213-14.135c-23.3-1.711-62.55,1.915-120.336,10.384-145.044,21.257,48.765-32.51,48.765-32.51l78.774,12.5,36.261,8.753Z",
    transform: "translate(-76.717 -299.048)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGuy);
export default __webpack_public_path__ + "static/media/alert-guy.52c4164135b0063e857c31261a0c42e1.svg";
export { ForwardRef as ReactComponent };